import { VisitMedicalServiceTableBean } from './shared/medicalServices/medicalServices.types';
import { VisitSettlementBean, VisitSettlementControl } from './visitSettlement.types';

export const getVisitSettlementValue = (control: VisitSettlementControl): VisitSettlementBean => {
   return control.watchInternal('visitSettlement') as VisitSettlementBean;
};

export const getVisitSettlementMedicalServicesValue = (
   control: VisitSettlementControl
): VisitMedicalServiceTableBean[] => {
   return control.watchInternal('visitSettlement.medicalServices') as VisitMedicalServiceTableBean[];
};
